export default [

     {
          path: '/database-schema/:databaseConfigId?',
          props: true,
          name: 'DatabaseSchema',
          component: () => import("@/views/Page/DatabaseSchema/DatabaseSchema.vue"),
           meta: {
               title: 'Database Schema',
          },
     },
     {
          path: '/database-schema/detail/:databaseSchemaId',
          name: 'DatabaseSchemaDetail',
          props: true,
          component: () => import("@/views/Page/DatabaseSchema/DatabaseSchemaDetail.vue"),
           meta: {
               title: 'Database Schema',
          },
     },
     {
          path: '/database-service-insight',
          name: 'DatabaseServiceInsight',
          props: true,
          component: () => import("@/views/Page/DatabaseServiceInsight/DatabaseServiceInsight.vue"),
           meta: {
               title: 'Database Service Insight',
          },
     }
];